import ColorIdentifier from '@components/ui/ColorIdentifier'
import config from '@config/seo_meta.json'
import Image from "next/legacy/image"
import { useState } from 'react'
interface Props {
  slice: any
}
const ArticleImageFullWidth = ({ slice }: Props) => {
  const { primary } = slice
  const colour = primary?.colour
  const colourName = primary?.colourName
  const image = primary?.image
  const imageCredit = primary?.imageCredit
  const [isHover, setIsHover] = useState(false)
  const handleHover = () => {
    setIsHover(true)
  }
  const handleLeave = () => {
    setIsHover(false)
  }
  const imageColour = {
    colorName: colourName,
    colorHexCode: colour,
  }
  return (
    <div className="bg-ui-light-grey wrapper pb-10 lg:pb-[88px] pt-8 lg:pt-10">
      <div className="flex flex-col gap-3">
        <div>
          {image && (
            <div
              onMouseOver={() => handleHover()}
              onMouseLeave={() => handleLeave()}
              className="w-full hidden lg:block  relative lg:h-[738px] h-[343px]"
            >
              <Image
                src={image?.url || '/product-img-placeholder.svg'}
                alt={image?.alt || config.openGraph.images[0].alt}
                layout="fill"
                objectFit="cover"
              />
              {isHover && (
                <div className="absolute w-full h-full bg-brand-dark-grey opacity-20"></div>
              )}
              {isHover && colour && colourName && (
                <div className="absolute bottom-7 left-6">
                  <ColorIdentifier color={imageColour} />
                </div>
              )}
            </div>
          )}
          {image && (
            <div className="w-full block lg:hidden  relative lg:h-[738px] h-[343px]">
              <Image
                src={image?.url || '/product-img-placeholder.svg'}
                alt={image?.alt || config.openGraph.images[0].alt}
                layout="fill"
                objectFit="cover"
              />

              {colour && colourName && (
                <div className="absolute bottom-5 left-4">
                  <ColorIdentifier color={imageColour} />
                </div>
              )}
            </div>
          )}
        </div>
        {imageCredit && (
          <div className="body-2 text-brand-dark-grey">{imageCredit}</div>
        )}
      </div>
    </div>
  )
}

export default ArticleImageFullWidth
